import React, { Component } from "react";
import { Link } from "react-router-dom"
import { Row, Col, Card, CardBody, FormGroup, Button, Label, Spinner, Modal, ModalHeader, ModalBody, Container, Input } from "reactstrap";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import BootstrapTable from "react-bootstrap-table-next";
import { createSlugfromName } from "../../helpers/methods";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import { isEmpty } from "lodash";

const PaymentModeGroup = [
  {
    label: "Payment Mode",
    options: [
      { label: "Cash", value: "Cash" },
      { label: "Bank Transfer", value: "Bank Transfer" },
      { label: "UPI", value: "UPI" },
      { label: "Online", value: "Online" },
    ]
  }
];


class PaymentDetail extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj) {
      this.props.history.push('/logout')
    } else if (!validateToken(this.obj.access)) {
      this.props.history.push('/logout')
    }
    if (!has_Permission(this.obj.user, 7, 'read')) {
      this.props.history.push('/itineraries')
    }
    this.state = {
      Banks: [],
      creditTrans: [],
      DebitTrans: [],
      count: 1,
      bank: false,
      upi: false,
      total_credit: 0,
      total_debit: 0,
      selectedPaymentMode: { label: "Cash", value: "Cash" },
      BankGroup: [],
      selectedBank: { label: "------------", value: "" },
      selectedUPI: { label: "------------", value: "" },
      selectedPaymentTo: { label: "------------", value: "" },
      UPIGroup: [],
      PaymentToOptions: [],
      selected_row: "",
      bank_detail: [],
      itinerary: null,
      pending_amount :0,
    };

    this.handleDebitSubmit = this.handleDebitSubmit.bind(this)
    this.handleEditDebit = this.handleEditDebit.bind(this)
    this.handleEditDebitSubmit = this.handleEditDebitSubmit.bind(this)
    this.handleCreditSubmit = this.handleCreditSubmit.bind(this)
    this.handleEditCredit = this.handleEditCredit.bind(this)
    this.handleEditCreditSubmit = this.handleEditCreditSubmit.bind(this)
    this.tog_credit = this.tog_credit.bind(this)
    this.tog_editcredit = this.tog_editcredit.bind(this)
    this.tog_debit = this.tog_debit.bind(this)
    this.tog_edit_debit = this.tog_edit_debit.bind(this)
    this.handleDeleteCreditPaymentRow = this.handleDeleteCreditPaymentRow.bind(this)
    this.handleDeleteDebitPaymentRow = this.handleDeleteDebitPaymentRow.bind(this)
    this.calculatePendings = this.calculatePendings.bind(this)
  }

  tog_credit() {
    this.setState(prevState => ({
      model_credit: !prevState.model_credit
    }));
    this.removeBodyCss();
  }

  tog_editcredit() {
    this.setState(prevState => ({
      model_editcredit: !prevState.model_editcredit
    }));
    this.removeBodyCss();
  }

  tog_debit() {
    this.setState({ bank_detail: [] })
    this.setState(prevState => ({
      model_debit: !prevState.model_debit
    }));
    this.removeBodyCss();
  }

  tog_edit_debit() {
    this.setState({ bank_detail: [] })
    this.setState(prevState => ({
      model_edit_debit: !prevState.model_edit_debit
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidMount = () => {
    document.title = "Itinerary Payment Detail | Planmans"
    this.loadBankData()
    this.loadItineraryData()
    this.loadItineraryCreditTrans()
    this.loadItineraryDebitTrans()
    this.loadItineraryHotels()

  }

  async loadItineraryData() {
    let id = this.props.match.params.id
    console.log(id, "Called---")
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itineraries/${id}`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          console.log(data, "--------------------Itinenrary")
          this.setState({ itinerary: data })

        },

        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  async loadBankData() {

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/cms/payment-detail/`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = []
          let upioptions = []
          data.map(bank => {
            options.push({ label: `${bank.bank_name} (${bank.branch_name} Branch) (${bank.account_no})`, value: bank.id })
            upioptions.push({ label: bank.upi, value: bank.id })
          })

          let BankGroup = [
            {
              label: "Bank",
              options: options
            }
          ];
          let UPIGroup = [
            {
              label: "UPI",
              options: upioptions
            }
          ];
          this.setState({ BankGroup, UPIGroup, Banks: data })

        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  async loadItineraryCreditTrans() {
    let id = this.props.match.params.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-credit-transactions/?itinerary__id=${id}`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let total_credit = 0
          for (let i = 0; i < data.length; i++) {
            total_credit = total_credit + parseInt(data[i].amount)
          }
          console.log(data, "creditTrans")
          this.setState({ creditTrans: data, total_credit })
        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  async loadItineraryDebitTrans() {
    let id = this.props.match.params.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-debit-transactions/?itinerary__id=${id}`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let total_debit = 0
          for (let i = 0; i < data.length; i++) {
            total_debit = total_debit + parseInt(data[i].amount)
            console.log(parseInt(data[i].amount), "==>", data[i].amount)
          }

          this.setState({ DebitTrans: data, total_debit })
        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  // Load Hotels Added in Initenary 
  async loadItineraryHotels() {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-hotels/?itinerary__id=${this.props.match.params.id}`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = []
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].hotel.name, value: `hotel_${data[i].hotel.id}` },)
          }
          let HotelOptions = {
            label: "Hotels",
            options: options
          }
          let payment_to_options = this.state.PaymentToOptions
          payment_to_options.push(HotelOptions)
          this.setState({ PaymentToOptions: payment_to_options })
          this.loadItineraryVehicles()


        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )

  }

  // Load Vehicle Added in Initenary 
  async loadItineraryVehicles() {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-vehicles/?itinerary__id=${this.props.match.params.id}`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = []
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].vehicle.name, value: `vehicle_${data[i].vehicle.id}` },)
          }
          let VehicleOptions = {
            label: "Vehicles",
            options: options
          }
          let payment_to_options = this.state.PaymentToOptions
          payment_to_options.push(VehicleOptions)
          this.setState({ PaymentToOptions: payment_to_options })
          this.loadItineraryActivities()

        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  // load all itinerary activities based on itinerary id 
  async loadItineraryActivities() {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itinerary-activities/?itinerary__id=${this.props.match.params.id}`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          let options = []
          for (let i = 0; i < data.length; i++) {
            options.push({ label: data[i].activity.name, value: `activity_${data[i].activity.id}` },)
          }
          let ActivityOptions = {
            label: "Activities",
            options: options
          }
          let payment_to_options = this.state.PaymentToOptions
          payment_to_options.push(ActivityOptions)
          this.setState({ PaymentToOptions: payment_to_options })

        },
        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  async loadPaymentDetail(url) {
    if (url) {
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      };
      fetch(url, requestOptions)
        .then(res => res.json())
        .then(
          (data) => {
            console.log(data, "-data")
            this.setState({ bank_detail: data.results[0] })

          },
          (error) => {
            console.log(error, 'error--------------')
          }
        )
    }
  }



  HandleSelectedpaymentTo = selectedPaymentTo => {
    let url = null
    let data = (selectedPaymentTo.value).split("_")
    if (data[0] === "hotel") {
      url = `${BaseUrl}/api/hotels/hotel-bank-detail/?hotel__id=${data[1]}`
    } else if (data[0] === "vehicle") {
      url = `${BaseUrl}/api/vehicles/vehicle-bank-detail/?vehicle__id=${data[1]}`
    } else if (data[0] === "activity") {
      url = `${BaseUrl}/api/activities/activity-bank-detail/?activity__id=${data[1]}`
    }
    this.loadPaymentDetail(url)
    this.setState({ selectedPaymentTo })

  }


  // Delete selected Credit payment detail 
  handleDeleteCreditPaymentRow(row) {
    if (this.obj.user.role !== 1 && !this.obj.user.is_superuser) {
      this.setState({ permission_error: true, payment_alert_confirm: false, payment_id: "" })
    } else {
      const requestOptions = {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${this.obj.access}` },
      };
      fetch(`${BaseUrl}/api/itineraries/itinerary-credit-transactions/${row.id}/`, requestOptions)
        .then(res => {
          if (res.status >= 400) {
            console.log("error")
          }
          else {
            this.loadItineraryCreditTrans()
            this.setState({
              payment_id: "",
              payment_success_confirm: true,
              payment_alert_confirm: false,
              dynamic_title: "Deleted!",
              dynamic_description: "Row has been deleted."
            })
          }
        }
        )
    }
  }

  // Delete selected Debit payment detail 
  handleDeleteDebitPaymentRow(row) {
    if (this.obj.user.role !== 1 && !this.obj.user.is_superuser) {
      this.setState({ permission_error: true, payment_alert_confirm: false, debit_payment_alert_confirm: false, payment_id: "" })
    } else {
      const requestOptions = {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${this.obj.access}` },
      };
      fetch(`${BaseUrl}/api/itineraries/itinerary-debit-transactions/${row.id}/`, requestOptions)
        .then(res => {
          if (res.status >= 400) {
            console.log("error")
          }
          else {
            this.loadItineraryDebitTrans()
            this.setState({
              payment_id: "",
              payment_success_confirm: true,
              debit_payment_alert_confirm: false,
              dynamic_title: "Deleted!",
              dynamic_description: "Row has been deleted."
            })
          }
        }
        )
    }
  }

  handleSelectedPaymentMode = selectedPaymentMode => {
    this.setState({ selectedPaymentMode })
  }

  handleSelectedUPI = selectedUPI => {
    this.setState({ selectedUPI })
  }

  handleSelectedBank = selectedBank => {
    this.setState({ selectedBank })
  }

  handleDebitSubmit(e, values) {
    const { selectedPaymentMode, itinerary, selectedPaymentTo } = this.state
    this.setState({ debitloading: true })
    let data = {}
    data["to"] = selectedPaymentTo.label
    data["mode"] = selectedPaymentMode.value
    data["account_name"] = values.account_name ? values.account_name : ""
    data["account_no"] = values.account_no ? values.account_no : ""
    data["bank_name"] = values.bank_name ? values.bank_name : ""
    data["branch_name"] = values.branch_name ? values.branch_name : ""
    data["ifsc"] = values.ifsc ? values.ifsc : ""
    data["upi"] = values.upi ? values.upi : ""
    data["transaction_id"] = values.transaction_id ? values.transaction_id : ""
    data["amount"] = values.amount
    data["pending"] = values.pending
    data["date"] = values.date
    data["comment"] = document.getElementById("textarea").value
    data["itinerary"] = itinerary.id
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
    };
    fetch(`${BaseUrl}/api/itineraries/itinerary-debit-transactions/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          res.json()
            .then(
              (data) => {
                console.log(data, "-error ")
                this.setState({ debitloading: false })
              }
            )
        } else {
          this.setState({ debitloading: false, model_debit: false })
          this.loadItineraryDebitTrans()
        }
      }
      )

  }

  handleCreditSubmit(e, values) {
    const { selectedPaymentMode, selectedBank, selectedUPI, itinerary, total_credit } = this.state
    this.setState({ creditloading: true })
    let data = {}
    data['end_user'] = values.end_user
    data['mode'] = selectedPaymentMode.value
    data['itinerary'] = itinerary.id
    if (selectedPaymentMode.value === "Bank Transfer") {
      data['bank'] = selectedBank.value
    } else if (selectedPaymentMode.value === "UPI") {
      data['bank'] = selectedUPI.value
    } else {
      data['bank'] = ""
    }
    data['amount'] = values.amount
    data['pending'] = parseInt(itinerary.pkg_const_margin) - (parseInt(total_credit) + parseInt(values.amount))
    data['date'] = values.date
    data['comment'] = document.getElementById("textarea").value
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
    };
    fetch(`${BaseUrl}/api/itineraries/itinerary-credit-transactions/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          res.json()
            .then(
              (data) => {
                console.log(data, "-error ")
                this.setState({ creditloading: false })

              }
            )
        }
        else {
          this.setState({ creditloading: false })
          this.tog_credit()
          this.loadItineraryCreditTrans()
        }
      }
      )

  }

  handleEditCredit(row) {
    const { Banks } = this.state
    let selectedPaymentMode = { label: row.mode, value: row.mode }
    let selectedBank = { label: "------------", value: "" }
    let selectedUPI = { label: "------------", value: "" }
    if (row.mode === "Bank Transfer" || row.mode === "UPI")
      for (let i = 0; i < Banks.length; i++) {
        if (row.mode === "Bank Transfer" && Banks[i].id === row.bank.id) {
          selectedBank = { label: `${Banks[i].bank_name} (${Banks[i].branch_name} Branch) (${Banks[i].account_no})`, value: Banks[i].id }
        }
        if (row.mode === "UPI" && Banks[i].id === row.bank.id) {
          selectedUPI = { label: Banks[i].upi, value: Banks[i].id }
        }

      }
    this.setState({ selected_row: row, selectedPaymentMode, selectedBank, selectedUPI })
    this.tog_editcredit()

  }

  handleEditCreditSubmit(e, values) {
    const { selectedPaymentMode, selectedBank, selectedUPI, itinerary, selected_row } = this.state
    this.setState({ editcreditloading: true })
    console.log(itinerary, "---------------lklklklk")
    let data = {}
    data['end_user'] = values.end_user
    data['mode'] = selectedPaymentMode.value
    data['itinerary'] = itinerary.id
    if (selectedPaymentMode.value === "Bank Transfer") {
      data['bank'] = selectedBank.value
    } else if (selectedPaymentMode.value === "UPI") {
      data['bank'] = selectedUPI.value
    } else {
      data['bank'] = ""
    }
    data['amount'] = values.amount
    data['pending'] = (parseInt(selected_row.pending) + parseInt(selected_row.amount)) - parseInt(values.amount)
    data['date'] = values.date
    data['comment'] = document.getElementById("textarea").value
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
    };
    fetch(`${BaseUrl}/api/itineraries/itinerary-credit-transactions/${selected_row.id}/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          res.json()
            .then(
              (data) => {
                console.log(data, "-error ")
                this.setState({ editcreditloading: false })

              }
            )
        }
        else {
          this.setState({ editcreditloading: false, selected_row: "" })
          this.tog_editcredit()
          this.loadItineraryCreditTrans()
        }
      }
      )

  }

  handleEditDebit(row) {
    let selectedPaymentMode = { label: row.mode, value: row.mode }

    this.setState({ selected_row: row, selectedPaymentMode, })
    this.calculatePendings(row, row.amount)
    this.tog_edit_debit()

  }

  calculatePendings(selected_row, current_amount){
    const { DebitTrans } = this.state
    let pending = 0
    let till_deposit  = 0
    for (let i=0 ; i< DebitTrans.length; i++){
      if(typeof selected_row === 'string' ){
        if(selected_row === DebitTrans[i].to){
          till_deposit = parseInt(till_deposit) + parseInt(DebitTrans[i].amount)
          pending = DebitTrans[i].pending
        }
      }
      else if(selected_row.to === DebitTrans[i].to){
        till_deposit = parseInt(till_deposit) + parseInt(DebitTrans[i].amount)
        if(selected_row.id === DebitTrans[i].id ){
          break
        }
        pending = DebitTrans[i].pending
      }
      
    }
    this.setState({pending_amount: parseInt(pending) - parseInt(current_amount) })
  }

  handleEditDebitSubmit(e, values) {
    const { selectedPaymentMode, itinerary, selected_row } = this.state
    this.setState({ editdebitloading: true })
    let data = {}
    data["to"] = values.to
    data["mode"] = selectedPaymentMode.value
    data["account_name"] = values.account_name ? values.account_name : ""
    data["account_no"] = values.account_no ? values.account_no : ""
    data["bank_name"] = values.bank_name ? values.bank_name : ""
    data["branch_name"] = values.branch_name ? values.branch_name : ""
    data["ifsc"] = values.ifsc ? values.ifsc : ""
    data["upi"] = values.upi ? values.upi : ""
    data["transaction_id"] = values.transaction_id ? values.transaction_id : ""
    data["amount"] = values.amount
    data["pending"] = values.pending
    data["date"] = values.date
    data["comment"] = document.getElementById("edit_textarea").value
    data["itinerary"] = itinerary.id
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
    };
    fetch(`${BaseUrl}/api/itineraries/itinerary-debit-transactions/${selected_row.id}/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          res.json()
            .then(
              (data) => {
                console.log(data, "-error ")
                this.setState({ editdebitloading: false, })

              }
            )
        }
        else {
          this.setState({ editdebitloading: false, selected_row: "" })
          this.tog_edit_debit()
          this.loadItineraryDebitTrans()
        }
      }
      )
  }

  render() {
    const { creditTrans, DebitTrans, itinerary } = this.state

    let breadcrumbItems = [
      { title: "Itineraries", link: "/itineraries" },
      { title: itinerary?.name, link: `/itinerary-detail/${itinerary?.id}` },
      { title: "Payment Detail", link: "#" },]

    const Creditcolumns = [
      {
        dataField: "id",
        text: "ID",
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row, rowIndex) => {
          return `Cr-${rowIndex + 1}`

        },
      },
      {
        dataField: "end_user",
        text: "From",
        headerStyle: { backgroundColor: '#f79934' },
      },
      {
        dataField: "mode",
        text: "Mode",
        headerStyle: { backgroundColor: '#f79934' },
      },
      {
        dataField: "bank",
        text: "Bank",
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => {
          return row.mode === "Bank Transfer" && row.bank ? row.bank.bank_name : "-"

        },
      },
      {
        dataField: "upi",
        isDummyField: true,
        text: "UPI",
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => {
          return row.mode === "UPI" && row.bank ? row.bank.upi : "-"

        },
      },
      {
        dataField: "amount",
        text: "Advance",
        headerStyle: { backgroundColor: '#f79934' },
      },
      {
        dataField: "pending",
        text: "Pending",
        headerStyle: { backgroundColor: '#f79934' },
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => {

          let dateObj = new Date(row.date);

          return `${('0' + dateObj.getUTCDate()).slice(-2)}/${('0' + (dateObj.getUTCMonth() + 1)).slice(-2)}/${dateObj.getUTCFullYear()}`;
        },
      },
      {
        dataField: "comment",
        text: "Comment",
        sort: true,
        headerStyle: { backgroundColor: '#f79934' },

      },
      {
        dataField: "menu",
        isDummyField: true,
        text: "Action",
        editable: false,
        width: "10%",
        headerStyle: { backgroundColor: '#f79934', },
        formatter: (cellContent, row) => {
          return (
            <React.Fragment>
              <div style={{ textAlign: "center" }}>
                <Link to="#" onClick={() => this.handleEditCredit(row)} className="text-primary me-2"><i className="mdi mdi-pencil font-size-18"></i></Link>
                <Link to="#" onClick={() => this.setState({ payment_alert_confirm: true, payment_id: row })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
              </div>
            </React.Fragment>
          )

        }
      },
    ];

    const columns = [
      {
        dataField: "id",
        text: "ID",
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row, rowIndex) => {
          return `Dr-${rowIndex + 1}`

        },
      },
      {
        dataField: "to",
        text: "To ",
        headerStyle: { backgroundColor: '#f79934' },

      },
      {
        dataField: "mode",
        text: "Mode",
        headerStyle: { backgroundColor: '#f79934' },
      },
      {
        dataField: "bank_name",
        text: "Bank",
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => {
          return row.mode === "Bank Transfer" ? row.account_name : "-"

        },
      },
      {
        dataField: "upi",
        text: "UPI",
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => {
          return row.mode === "UPI" ? row.upi : "-"

        },
      },
      {
        dataField: "transaction_id",
        text: "Transaction Id",
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => {
          return row.mode === "Online" ? row.transaction_id : "-"

        },
      },
      {
        dataField: "amount",
        text: "Advance",
        sort: true,
        headerStyle: { backgroundColor: '#f79934' },
      },
      {
        dataField: "pending",
        text: "Pending",
        sort: true,
        headerStyle: { backgroundColor: '#f79934' },
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => {

          let dateObj = new Date(row.date);
          return `${('0' + dateObj.getUTCDate()).slice(-2)}/${('0' + (dateObj.getUTCMonth() + 1)).slice(-2)}/${dateObj.getUTCFullYear()}`;
        },
      },

      {
        dataField: "comment",
        text: "Comment",
        sort: true,
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => (
          cellContent.substring(0, 40) + " ..."
        ),
        title: (cell) => `${cell}`
      },
      {
        dataField: "menu",
        isDummyField: true,
        text: "Action",
        editable: false,
        width: "10%",
        headerStyle: { backgroundColor: '#f79934' },
        formatter: (cellContent, row) => {
          return (
            <React.Fragment>
              <div style={{ textAlign: "center" }}>
                {has_Permission(this.obj.user, 7, 'edit') ?
                  <Link to="#" onClick={() => this.handleEditDebit(row)} className="text-primary me-3"><i className="mdi mdi-pencil font-size-18"></i></Link>
                  : null}
                {has_Permission(this.obj.user, 7, 'delete') ?
                  <Link to="#" onClick={() => this.setState({ debit_payment_alert_confirm: true, payment_id: row })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                  : null}
              </div>
            </React.Fragment>
          )

        }
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>

            <Breadcrumbs title={"Payment Detail"} breadcrumbItems={breadcrumbItems} />
            {!isEmpty(this.state.itinerary) ? (
              <>
                <Row>
                  <div className="timeline-block my-3">
                    <div className="time-show-btn mt-0">

                      {has_Permission(this.obj.user, 1, 'edit') ?
                        <Link to={`/itinerary-detail/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-clipboard-list font-size-15"></i> Itinerary Detail</Link>
                        : null
                      }
                      
                      {has_Permission(this.obj.user, 0, 'edit') ?
                        <Link to={`/itinerary-daily-plan/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-clipboard-list font-size-15"></i> Itinerary Plan</Link>
                        : null
                      }

                      {has_Permission(this.obj.user, 7, 'read') ?
                        <Link to={`/invoices/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-file-invoice-dollar font-size-15"></i> Invoices</Link>
                        : null}
                      {has_Permission(this.obj.user, 1, 'edit') ?
                        <Link to={`/itinerary-terms-&-condition/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className=" far fa-list-alt font-size-15"></i> Terms & Conditions</Link>
                        : null}

                        <Link to={`/itinerary/${this.state.itinerary.id}/${createSlugfromName(this.state.itinerary.name)}`} target="_blank" className="btn btn-link btn-rounded w-lg"><i className="far fa-eye font-size-15"></i> View Itinerary</Link>

                    </div>
                  </div>
                </Row>

                <Row>
                  <Col xs={12}>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col sm="6">
                            <h4 className="card-title">{"Credit Transactions"} </h4>
                          </Col>
                          <Col sm="6">
                            <div >
                              <p className="text-end"><b>Total Credit: ₹ {this.state.total_credit}</b></p>
                            </div>
                          </Col>
                        </Row>


                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            data={creditTrans}
                            columns={Creditcolumns}
                            hover
                            responsive
                            classes={
                              "table align-middle table-nowrap"
                            }
                            headerWrapperClasses={"table-light"}
                            sort={{ dataField: 'date', order: 'asc' }}
                          />

                        </div>
                        {has_Permission(this.obj.user, 7, 'create') ?
                          <div style={{ textAlign: "center" }}>
                            <Button color="secondary" outline className="waves-effect me-1 m-3 " onClick={this.tog_credit}>
                              Add New Detail
                            </Button>
                          </div>
                          : null}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col sm="6">
                            <h4 className="card-title">{"Debit Transactions"} </h4>
                          </Col>
                          <Col sm="6">
                            <div >
                              <p className="text-end"><b>Total Debit: ₹ {this.state.total_debit}</b></p>
                            </div>
                          </Col>
                        </Row>


                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            data={DebitTrans}
                            columns={columns}
                            hover
                            responsive
                            classes={
                              "table align-middle table-nowrap"
                            }
                            headerWrapperClasses={"table-light"}
                            sort={{ dataField: 'date', order: 'asc' }}
                          />

                        </div>
                        {has_Permission(this.obj.user, 7, 'create') ?
                          <div style={{ textAlign: "center" }}>
                            <Button color="secondary" outline className="waves-effect me-1 m-3" onClick={this.tog_debit}>
                              Add New Detail
                            </Button>
                          </div>
                          : null}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>) :
              (
                <div className="d-flex align-items-center justify-content-center min-vh-100">
                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />
                </div>
              )}
          </Container>
        </div>
        {/* Add Credit Payment Detail */}
        <Col sm={6} md={4} xl={3} className="mt-4">

          <Modal
            isOpen={this.state.model_credit}
            toggle={this.tog_credit}
            centered={true}
          >
            <ModalHeader toggle={this.tog_credit}>
              Add Credit Transaction Detail
            </ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleCreditSubmit} >
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="start_date">From</Label>
                      <AvField
                        name="end_user"
                        type="text"
                        placeholder="Payment From"
                        errorMessage="Enter Payment From"
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Payment Mode</Label>
                      <Select
                        value={this.state.selectedPaymentMode}
                        onChange={this.handleSelectedPaymentMode}
                        options={PaymentModeGroup}
                        classNamePrefix="select2-selection"
                        id={'category'}
                      />
                    </div>
                  </Col>

                </Row>
                {this.state.selectedPaymentMode.value === "Bank Transfer" ?
                  <Row>
                    <Col md="12">
                      <div className="mb-3">
                        <Label className="form-label">Select Bank</Label>
                        <Select
                          value={this.state.selectedBank}
                          onChange={this.handleSelectedBank}
                          options={this.state.BankGroup}
                          classNamePrefix="select2-selection"
                          id={'bank'}
                        />
                      </div>
                    </Col>
                  </Row> : null}
                {this.state.selectedPaymentMode.value === "UPI" ?
                  <Row>
                    <Col md="12">
                      <div className="mb-3">
                        <Label className="form-label">Select UPI</Label>
                        <Select
                          value={this.state.selectedUPI}
                          onChange={this.handleSelectedUPI}
                          options={this.state.UPIGroup}
                          classNamePrefix="select2-selection"
                          id={'upi'}
                        />
                      </div>
                    </Col>
                  </Row> : null}
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <AvField
                        name="amount"
                        label="Payment Amount"
                        type="number"
                        placeholder="Enter Payment Amount"
                        errorMessage="Enter Only Digits"
                        validate={{
                          required: { value: true },
                          pattern: {
                            value: "^[0-9]+$",
                            errorMessage: "Only Digits"
                          }
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="payment_date">Payment Date</Label>
                      <AvField
                        id='payment_date'
                        name="date"
                        type="date"
                        placeholder="Payment Date"
                        errorMessage="Select Date"
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>

                  <div className="mb-3">
                    <Label className="form-label " htmlFor="textarea">Comment</Label>
                    <Input
                      type="textarea"
                      id="textarea"
                      rows="2"
                      placeholder="Comment"
                    />
                  </div>
                </Row>
                <FormGroup className="mb-0 mt-3">
                  {this.state.creditloading ? (
                    <Spinner className="me-2 mt-2" color="primary" />
                  ) : (
                    <div>

                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                    </div>
                  )}
                </FormGroup>
              </AvForm>

            </ModalBody>
          </Modal>
        </Col>
        {/* Edit Credit payment Detail */}
        <Col sm={6} md={4} xl={3} className="mt-4">

          <Modal
            isOpen={this.state.model_editcredit}
            toggle={this.tog_editcredit}
            centered={true}
          >
            <ModalHeader toggle={this.tog_editcredit}>
              Edit Credit Transaction
            </ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleEditCreditSubmit} >
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="start_date">From</Label>
                      <AvField
                        name="end_user"
                        type="text"
                        value={this.state.selected_row.end_user}
                        errorMessage="Enter Payment From"
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label className="form-label">Payment Mode</Label>
                      <Select
                        value={this.state.selectedPaymentMode}
                        onChange={this.handleSelectedPaymentMode}
                        options={PaymentModeGroup}
                        classNamePrefix="select2-selection"
                        id={'category'}
                      />
                    </div>
                  </Col>

                </Row>
                {this.state.selectedPaymentMode.value === "Bank Transfer" ?
                  <Row>
                    <Col md="12">
                      <div className="mb-3">
                        <Label className="form-label">Select Bank</Label>
                        <Select
                          value={this.state.selectedBank}
                          onChange={this.handleSelectedBank}
                          options={this.state.BankGroup}
                          classNamePrefix="select2-selection"
                          id={'edit_bank'}
                        />
                      </div>
                    </Col>
                  </Row> : null}
                {this.state.selectedPaymentMode.value === "UPI" ?
                  <Row>
                    <Col md="12">
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="edit_upi">Select UPI</Label>
                        <Select
                          value={this.state.selectedUPI}
                          onChange={this.handleSelectedUPI}
                          options={this.state.UPIGroup}
                          classNamePrefix="select2-selection"
                          id={'edit_upi'}
                        />
                      </div>
                    </Col>
                  </Row> : null}
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <AvField
                        name="amount"
                        label="Payment Amount"
                        type="number"
                        value={parseInt(this.state.selected_row.amount)}
                        errorMessage="Enter Only Digits"
                        validate={{
                          required: { value: true },
                          pattern: {
                            value: "^[0-9]+$",
                            errorMessage: "Only Digits"
                          }
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="start_date">Start Date</Label>
                      <AvField
                        name="date"
                        type="date"
                        value={this.state.selected_row.date}
                        placeholder="Payment Date"
                        errorMessage="Invalid Date"
                        validate={{
                          required: { value: true },

                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>

                  <div className="mb-3">
                    <Label className="form-label " htmlFor="textarea">Comment</Label>
                    <Input
                      type="textarea"
                      id="textarea"
                      rows="2"
                      defaultValue={this.state.selected_row.comment}
                      placeholder="Comment"
                    />
                  </div>
                </Row>


                <FormGroup className="mb-0 mt-3">
                  {this.state.editcreditloading ? (
                    <Spinner className="me-2 mt-2" color="primary" />
                  ) : (
                    <div>

                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                    </div>
                  )}
                </FormGroup>
              </AvForm>

            </ModalBody>
          </Modal>
        </Col>
        {/* Add Debit Payment Detail */}
        <Col sm={6} md={4} xl={3} className="mt-4">

          <Modal
            isOpen={this.state.model_debit}
            toggle={this.tog_debit}
            centered={true}
          >
            <ModalHeader toggle={this.tog_debit}>
              Add Debit Transaction Detail
            </ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleDebitSubmit} >
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label">Payment Mode</Label>
                      <Select
                        value={this.state.selectedPaymentMode}
                        onChange={this.handleSelectedPaymentMode}
                        options={PaymentModeGroup}
                        classNamePrefix="select2-selection"
                        id={'payment_mode'}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label">Payment To</Label>
                      <Select
                        value={this.state.selectedPaymentTo}
                        onChange={this.HandleSelectedpaymentTo}
                        options={this.state.PaymentToOptions}
                        classNamePrefix="select2-selection"
                        id={'payment_to'}
                      />
                    </div>
                  </Col>

                </Row>
                {this.state.selectedPaymentMode.value === "Bank Transfer" ?
                  <>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="account_name">Account Name</Label>
                          <AvField
                            name="account_name"
                            type="text"
                            placeholder="Enter Account Name"
                            errorMessage="Enter Account Name"
                            value={this.state.bank_detail?.account_name}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="account_name"

                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <AvField
                            name="account_no"
                            label="Account Number"
                            placeholder="Enter Account Number"
                            type="number"
                            value={this.state.bank_detail?.account_no}
                            errorMessage="Enter Only Digits"
                            validate={{
                              required: { value: true },
                              pattern: {
                                value: "^[0-9]+$",
                                errorMessage: "Only Digits"
                              }
                            }}
                          />
                        </div>
                      </Col>

                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label " htmlFor="bank_name">Bank Name</Label>
                          <AvField
                            name="bank_name"
                            type="text"
                            placeholder="Enter Bank Name"
                            errorMessage="Enter Bank Name"
                            value={this.state.bank_detail?.bank_name}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="bank_name"

                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label " htmlFor="branch_name">Branch Name</Label>
                          <AvField
                            name="branch_name"
                            type="text"
                            placeholder="Enter Branch Name"
                            errorMessage="Enter Branch Name"
                            value={this.state.bank_detail?.branch_name}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="branch_name"

                          />
                        </div>
                      </Col>

                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label " htmlFor="ifsc">IFSC Code</Label>
                          <AvField
                            name="ifsc"
                            type="text"
                            placeholder="Enter IFSC Name"
                            errorMessage="Enter IFSC Code"
                            value={this.state.bank_detail?.ifsc}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="ifsc"

                          />
                        </div>
                      </Col>
                    </Row>

                  </> : null}
                {this.state.selectedPaymentMode.value === "UPI" ?
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label className="form-label " htmlFor="debit_upi">UPI</Label>
                        <AvField
                          name="upi"
                          type="text"
                          placeholder="Enter UPI"
                          errorMessage="Enter UPI"
                          value={this.state.bank_detail?.upi}
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="debit_upi"

                        />
                      </div>
                    </Col>
                  </Row> : null}
                {this.state.selectedPaymentMode.value === "Online" ?
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label className="form-label " htmlFor="transaction_id">Transaction Id</Label>
                        <AvField
                          name="transaction_id"
                          type="text"
                          placeholder="Enter Transaction Id"
                          errorMessage="Enter Transaction Id"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="transaction_id"

                        />
                      </div>
                    </Col>
                  </Row> : null}
                  <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="start_date">Date</Label>
                      <AvField
                        name="date"
                        type="date"
                        placeholder="Payment Date"
                        errorMessage="Select Date"
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </div>
                  </Col>
                  </Row>
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <AvField
                        name="amount"
                        label="Payment Amount"
                        type="number"
                        placeholder="Enter Payment Amount"
                        errorMessage="Enter Only Digits"
                        onChange={(e)=> {this.calculatePendings(this.state.selectedPaymentTo.label, e.target.value)}}
                        validate={{
                          required: { value: true },
                          pattern: {
                            value: "^[0-9]+$",
                            errorMessage: "Only Digits"
                          }
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <AvField
                        name="pending"
                        label="Pending Amount"
                        type="number"
                        value={this.state.pending_amount}
                        errorMessage="Enter Only Digits"
                        validate={{
                          required: { value: true },
                          pattern: {
                            value: "^-?[0-9]+$",
                            errorMessage: "Only Digits"
                          }
                        }}
                      />
                    </div>
                  </Col>
                  
                </Row>
                <Row>

                  <div className="mb-3">
                    <Label className="form-label " htmlFor="textarea">Comment</Label>
                    <Input
                      type="textarea"
                      id="textarea"
                      rows="2"
                      placeholder="Comment"
                    />
                  </div>
                </Row>


                <FormGroup className="mb-0 mt-3">
                  {this.state.debitloading ? (
                    <Spinner className="me-2 mt-2" color="primary" />
                  ) : (
                    <div>

                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                    </div>
                  )}
                </FormGroup>
              </AvForm>

            </ModalBody>
          </Modal>
        </Col>
        {/* Edit Debit Payment Detail */}
        <Col sm={6} md={4} xl={3} className="mt-4">

          <Modal
            isOpen={this.state.model_edit_debit}
            toggle={this.tog_edit_debit}
            centered={true}
          >
            <ModalHeader toggle={this.tog_edit_debit}>
              Edit Debit Transaction Detail
            </ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleEditDebitSubmit} >
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label">Payment Mode</Label>
                      <Select
                        value={this.state.selectedPaymentMode}
                        onChange={this.handleSelectedPaymentMode}
                        options={PaymentModeGroup}
                        classNamePrefix="select2-selection"
                        id={'edit_payment_mode'}
                        isDisabled={true}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="account_name">Payment To </Label>
                      <AvField
                        name="to"
                        type="text"
                        value={this.state.selected_row.to}
                        errorMessage="Enter Payment To"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="edit_account_name"
                        disabled

                      />
                    </div>
                  </Col>

                </Row>
                {this.state.selectedPaymentMode.value === "Bank Transfer" ?
                  <>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="account_name">Account Name</Label>
                          <AvField
                            name="account_name"
                            type="text"
                            value={this.state.selected_row.account_name}
                            errorMessage="Enter Account Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="edit_account_name"
                            disabled

                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <AvField
                            name="account_no"
                            label="Account Number"
                            value={this.state.selected_row.account_no}
                            type="number"
                            errorMessage="Enter Only Digits"
                            disabled
                            validate={{
                              required: { value: true },
                              pattern: {
                                value: "^[0-9]+$",
                                errorMessage: "Only Digits"
                              }
                            }}
                          />
                        </div>
                      </Col>

                    </Row>

                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label " htmlFor="bank_name">Bank Name</Label>
                          <AvField
                            name="bank_name"
                            type="text"
                            value={this.state.selected_row.bank_name}
                            errorMessage="Enter Bank Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="edit_bank_name"
                            disabled

                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label " htmlFor="branch_name">Branch Name</Label>
                          <AvField
                            name="branch_name"
                            type="text"
                            value={this.state.selected_row.branch_name}
                            errorMessage="Enter Branch Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="edit_branch_name"
                            disabled

                          />
                        </div>
                      </Col>

                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label " htmlFor="ifsc">IFSC Code</Label>
                          <AvField
                            name="ifsc"
                            type="text"
                            value={this.state.selected_row.ifsc}
                            errorMessage="Enter IFSC Code"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="edit_ifsc"
                            disabled

                          />
                        </div>
                      </Col>
                    </Row>

                  </> : null}
                {this.state.selectedPaymentMode.value === "UPI" ?
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label className="form-label " htmlFor="debit_upi">UPI</Label>
                        <AvField
                          name="upi"
                          type="text"
                          value={this.state.selected_row.upi}
                          errorMessage="Enter UPI"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="edit_debit_upi"
                          disabled

                        />
                      </div>
                    </Col>
                  </Row> : null}
                {this.state.selectedPaymentMode.value === "Online" ?
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label className="form-label " htmlFor="transaction_id">Transaction Id</Label>
                        <AvField
                          name="transaction_id"
                          type="text"
                          value={this.state.selected_row.transaction_id}
                          errorMessage="Enter Transaction Id"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="edit_transaction_id"
                          disabled

                        />
                      </div>
                    </Col>
                  </Row> : null}
                  <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="start_date">Date</Label>
                      <AvField
                        name="date"
                        type="date"
                        value={this.state.selected_row.date}
                        errorMessage="Select Date"
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </div>
                  </Col>
                  </Row>
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <AvField
                        name="amount"
                        label="Payment Amount"
                        type="number"
                        value={parseInt(this.state.selected_row.amount)}
                        onChange={(e)=> {this.calculatePendings(this.state.selected_row, e.target.value)}}
                        errorMessage="Enter Only Digits"
                        validate={{
                          required: { value: true },
                          pattern: {
                            value: "^-?[0-9]+$",
                            errorMessage: "Only Digits"
                          }
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <AvField
                        name="pending"
                        label="Pending Amount"
                        type="number"
                        value={this.state.pending_amount}
                        errorMessage="Enter Only Digits"
                        validate={{
                          required: { value: true },
                          pattern: {
                            value: "^-?[0-9]+$",
                            errorMessage: "Only Digits"
                          }
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>

                  <div className="mb-3">
                    <Label className="form-label " htmlFor="textarea">Comment</Label>
                    <Input
                      type="textarea"
                      id="edit_textarea"
                      defaultValue={this.state.selected_row.comment}
                      rows="2"
                      placeholder="Comment"
                    />
                  </div>
                </Row>


                <FormGroup className="mb-0 mt-3">
                  {this.state.editdebitloading ? (
                    <Spinner className="me-2 mt-2" color="primary" />
                  ) : (
                    <div>

                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                    </div>
                  )}
                </FormGroup>
              </AvForm>

            </ModalBody>
          </Modal>
        </Col>

        {this.state.payment_alert_confirm ? (
          <SweetAlert
            title="Are you sure?"
            warning
            showCancel
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={() => this.handleDeleteCreditPaymentRow(this.state.payment_id)}
            onCancel={() =>
              this.setState({
                payment_alert_confirm: false,
                payment_id: "",

              })
            }
          >
            You won't be able to revert this!
          </SweetAlert>
        ) : null}

        {/* Delete Debit Payment Alert  */}
        {this.state.debit_payment_alert_confirm ? (
          <SweetAlert
            title="Are you sure?"
            warning
            showCancel
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={() => this.handleDeleteDebitPaymentRow(this.state.payment_id)}
            onCancel={() =>
              this.setState({
                debit_payment_alert_confirm: false,
                payment_id: "",

              })
            }
          >
            You won't be able to revert this!
          </SweetAlert>
        ) : null}

        {this.state.payment_success_confirm ? (
          <SweetAlert
            success
            title={this.state.dynamic_title}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={() => this.setState({ payment_success_confirm: false, payment_alert_confirm: false })}
          >
            {this.state.dynamic_description}
          </SweetAlert>
        ) : null}
        {this.state.permission_error ? (
          <SweetAlert
            title="Permission Denied!"
            error
            // timeout={4000}
            // showConfirm={false}
            confirmBtnBsStyle="success"
            onConfirm={() => this.setState({ permission_error: false })}
          >
            You Don't Have Permission to Perform this Action
          </SweetAlert>
        ) : null}
      </React.Fragment>
    );
  }
}

export default PaymentDetail;
